module.exports = __webpack_public_path__ + "img/small-img2.1ad34d51.svg";